import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/report`;

const formatDay = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });

const Stat = ({ label, value, testId }) => (
  <div className="rounded-3xl bg-white border border-neutral-200 p-6 md:p-8">
    <div className="text-[11px] uppercase tracking-widest text-neutral-500">{label}</div>
    <div data-testid={testId} className="mt-3 text-4xl md:text-5xl font-semibold text-neutral-900 tabular-nums">{value}</div>
  </div>
);

export default function LeadReport() {
  const { reportKey } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    document.title = 'Lead Report | One Catalyst';
    fetch(`${API}?key=${encodeURIComponent(reportKey)}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setData)
      .catch(() => setError(true));
  }, [reportKey]);

  if (error) return <div data-testid="report-not-found" className="min-h-screen grid place-items-center text-neutral-500">Page not found</div>;
  if (!data) return <div data-testid="report-loading" className="min-h-screen grid place-items-center text-neutral-400">Loading…</div>;

  return (
    <main data-testid="lead-report-page" className="min-h-screen bg-[#F6F1EA] px-4 md:px-6 py-12 md:py-20">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3">
          <img src="/one-catalyst-logo.png" alt="One Catalyst" className="h-8 w-8 rounded-lg" />
          <span className="font-semibold text-neutral-900">One Catalyst</span>
        </div>
        <h1 className="mt-10 text-4xl sm:text-5xl font-semibold tracking-tight text-neutral-900">WhatsApp leads</h1>
        <p className="mt-3 text-sm md:text-base text-neutral-600">All-time clicks on “Get in Touch”, by day (India time).</p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3">
          <Stat label="Total clicks" value={data.total} testId="report-total" />
          <Stat label="From X ads" value={data.from_x} testId="report-from-x" />
          <Stat label="Other sources" value={data.total - data.from_x} testId="report-other" />
        </div>

        <div className="mt-6 rounded-3xl bg-white border border-neutral-200 overflow-hidden">
          <div className="grid grid-cols-[1fr_auto_auto] gap-6 px-6 py-4 text-[11px] uppercase tracking-widest text-neutral-500 border-b border-neutral-200">
            <span>Day</span><span className="w-16 text-right">Clicks</span><span className="w-20 text-right">From X</span>
          </div>
          {data.days.length === 0 && (
            <div data-testid="report-empty" className="px-6 py-12 text-center text-neutral-500">No WhatsApp clicks yet.</div>
          )}
          {data.days.map((d) => (
            <div key={d.date} data-testid={`report-row-${d.date}`} className="grid grid-cols-[1fr_auto_auto] gap-6 px-6 py-4 border-b last:border-0 border-neutral-100 text-neutral-900">
              <span>{formatDay(d.date)}</span>
              <span className="w-16 text-right tabular-nums">{d.total}</span>
              <span className="w-20 text-right tabular-nums">{d.from_x}</span>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
